import React from "react";

const ProductionOutline = ({
  primaryColor = "#5062F0",
  secondaryColor = "#FFFFFF",
  size = 44,
  title = "Production Outline",
  ...svgProps
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
    {...svgProps}
  >
    {title ? <title>{title}</title> : null}

    <rect width="44" height="44" rx="12" fill={primaryColor} />
    <path
      d="M30 31.0001H14L11 26.7778H33L30 31.0001Z"
      stroke={secondaryColor}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 22.5557L26 22.5557" stroke={secondaryColor} strokeWidth="1.3" strokeLinecap="round" />
    <path
      d="M23.6105 15.3632L23.0777 14.9908C22.9551 15.1662 22.9267 15.3908 23.0018 15.5913C23.0769 15.7917 23.2459 15.9423 23.4537 15.994L23.6105 15.3632ZM29 22.5556H28.35C28.35 22.9145 28.641 23.2056 29 23.2056V22.5556ZM15 22.5556V23.2056C15.359 23.2056 15.65 22.9145 15.65 22.5556H15ZM20.3895 15.3632L20.5463 15.994C20.7541 15.9423 20.9231 15.7917 20.9982 15.5913C21.0733 15.3908 21.0449 15.1662 20.9223 14.9908L20.3895 15.3632ZM24.1432 15.7355C24.4633 15.2776 24.65 14.7149 24.65 14.1111H23.35C23.35 14.4448 23.2473 14.7482 23.0777 14.9908L24.1432 15.7355ZM29.65 22.5556C29.65 18.7766 27.1614 15.5759 23.7672 14.7323L23.4537 15.994C26.2389 16.6862 28.35 19.343 28.35 22.5556H29.65ZM31.65 24.6667C31.65 23.1753 30.4962 21.9056 29 21.9056V23.2056C29.7129 23.2056 30.35 23.8262 30.35 24.6667H31.65ZM29 27.4278C30.4962 27.4278 31.65 26.158 31.65 24.6667H30.35C30.35 25.5072 29.7129 26.1278 29 26.1278V27.4278ZM15 27.4278H29V26.1278H15V27.4278ZM12.35 24.6667C12.35 26.158 13.5038 27.4278 15 27.4278V26.1278C14.2871 26.1278 13.65 25.5072 13.65 24.6667H12.35ZM15 21.9056C13.5038 21.9056 12.35 23.1753 12.35 24.6667H13.65C13.65 23.8262 14.2871 23.2056 15 23.2056V21.9056ZM20.2328 14.7323C16.8386 15.5759 14.35 18.7766 14.35 22.5556H15.65C15.65 19.343 17.7611 16.6862 20.5463 15.994L20.2328 14.7323ZM19.35 14.1111C19.35 14.7149 19.5367 15.2776 19.8568 15.7355L20.9223 14.9908C20.7527 14.7482 20.65 14.4448 20.65 14.1111H19.35ZM22 11.35C20.5038 11.35 19.35 12.6198 19.35 14.1111H20.65C20.65 13.2706 21.2871 12.65 22 12.65V11.35ZM24.65 14.1111C24.65 12.6198 23.4962 11.35 22 11.35V12.65C22.7129 12.65 23.35 13.2706 23.35 14.1111H24.65Z"
      fill={secondaryColor}
    />
  </svg>
);

export default React.memo(ProductionOutline);
